// Components
import TypographyCell from "@/Layouts/components/Tables/DataSmartTable/additional/TypographyCell";

// Types
import { IProspectNoteDialogContent } from "../types/salesLeads";
import { IProspectNote } from "@/DataPages/types/rci/salesLeads/model";

interface IProspectNoteRenderCellProps {
	title: string;
	value: IProspectNote[] | undefined;
	cellText: string;
	setContentDialogSelected: ({ title, data }: IProspectNoteDialogContent) => void;
}

const ProspectNoteRenderCell = (props: IProspectNoteRenderCellProps) => {
	const { title, value, cellText, setContentDialogSelected } = props;

	const haveValue = value && value.length > 0;

	const handleOpenDialog = () => {
		if (haveValue) {
			setContentDialogSelected({
				title,
				data: value,
			});
		}
	};

	if (!haveValue) {
		return null;
	}
	return (
		<TypographyCell onClick={handleOpenDialog} className={"!text-primary !font-sans underline decoration-primary cursor-pointer"}>
			{cellText}
		</TypographyCell>
	);
};

export default ProspectNoteRenderCell;
